/**
 * Get value of nested property by presents string path to property.
 *
 * @param {Object} theObject source object
 * @param {String} path string path to property
 * @param {Strgin} separator nested proerties seperator. Default `.`
 * @returns Source value or unedfined
 */

export default function getNested(theObject, path, separator) {
  try {
    separator = separator || '.'

    return path
      .replace('[', separator)
      .replace(']', '')
      .split(separator)
      .reduce(function (obj, property) {
        return obj[property]
      }, theObject)
  } catch (err) {
    return undefined
  }
}
